import { useMutation, useQueryClient } from "@tanstack/react-query";
import { merchantKeys } from "Api/Queries/Merchants/useGetMerchantQuery";
import { merchantsListKeys } from "Api/Queries/Merchants/useGetMerchantsQuery";
import {
  type MerchantFacilityDto,
  putMerchantsPublicIDFacilities,
} from "Infrastructure/Api/Api";
import { processResponseWithApiProblemDetails } from "Infrastructure/Api/ApiUtils";

export type UpdateMerchantFacilityParameters = {
  data: MerchantFacilityDto;
  publicID: string;
};

type Props = {
  onSuccess?: (data: MerchantFacilityDto) => void;
  onError?: () => void;
};

export const useUpdateMerchantFacilityMutation = ({
  onSuccess,
  onError,
}: Props = {}) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: processResponseWithApiProblemDetails(
      ({ data, publicID }: UpdateMerchantFacilityParameters) =>
        putMerchantsPublicIDFacilities(data, publicID),
    ),
    onSuccess: async (data: MerchantFacilityDto) => {
      await Promise.all([
        queryClient.invalidateQueries({ queryKey: merchantKeys.all }),
        queryClient.invalidateQueries({ queryKey: merchantsListKeys.all }),
      ]);
      onSuccess?.(data);
    },
    onError,
  });
};
